// extracted by mini-css-extract-plugin
module.exports = {"badge":"EffectBadge_badge__C4Z1m","pdp":"EffectBadge_pdp__pBwx8","image":"EffectBadge_image__4Afj4","inner":"EffectBadge_inner__QdvB4"};